import { create } from 'zustand';

interface SplitterState {
  // Main horizontal splitter (FileManager | Editor+Bottom | Smart)
  mainSizes: (number | string)[];
  setMainSizes: (sizes: (number | string)[]) => void;
  
  // Vertical splitter (Editor | Bottom tabs)
  verticalSizes: (number | string)[];
  setVerticalSizes: (sizes: (number | string)[]) => void;
  
  // Reset functions
  resetMainSizes: () => void;
  resetVerticalSizes: () => void;
}

export const useSplitterStore = create<SplitterState>((set) => ({
  // Default sizes for main horizontal splitter
  mainSizes: ['15%', '60%', '20%'],
  setMainSizes: (sizes) => set({ mainSizes: sizes }),
  
  // Default sizes for vertical splitter
  verticalSizes: ['80%', '0%'],
  setVerticalSizes: (sizes) => set({ verticalSizes: sizes }),
  
  // Reset to default sizes
  resetMainSizes: () => set({ mainSizes: ['20%', '60%', '20%'] }),
  resetVerticalSizes: () => set({ verticalSizes: ['80%', '20%'] }),
}));
